import { createSelector } from 'reselect';
import {
  SELECT_CATEGORY,
  CHANGE_MENUITEMS,
  LOAD_CATEGORY,
  LOADING,
  LOAD_PAGINATION_MENU_ITEMS,
  UNSET_MENU,
  UPDATE_MENUITEMS,
  LOADINFINITE_MENUITEMS,
  ISINFINITEBOOLVALUE,
  ADDMENUIDS,
  INFINITE_SCROLL,
  CLICKBOOLEAN,
  CHANGE_CATEGORYID,
} from './actions';
import { LOAD_ITEMS } from '../../actions/MenuItemsActions';
import { REHYDRATE } from 'redux-persist/constants';
import { get, orderBy, isEmpty } from 'lodash';
const INITIAL_STATE = {
  total: 0,
  category: 0,
  selectedCategory: '',
  searchText: '',
  categories: [],
  mainMenuItemClicked: '',
  subMenuItemClicked: '',
  menuItems: [],
  menuCategories: [],
  menuArray: [],
  pager: {},
  bannerImage: '',
  bannerTxt: '',
  items: [],
  menuItemsResponse: false,
  infiniteBoolValue: false,
  loading: false,
  mainMenuItemName: '',
  infiniteScroll: false,
  clickBooleanSubMenu: false,
};

export default function MenuCategoryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SELECT_CATEGORY:
      if (action.selectFirstByDefault) {
        let subCategoryMenu = [];
        state.subMenuItemClicked = 0;
        state.bannerTxt = '';
        const menuCategories = get(state, 'menuCategories.menu_category', []);
        menuCategories.forEach((item, id) => {
          if (item.id === action.id && item.type === 'group') {
            state.mainMenuItemClicked = action.id;
            state.mainMenuOrderBy = item.orderby;
            state.mainMenuItemName = item.text;
          }
          if (action.id === item.parentid) {
            subCategoryMenu.push({
              id: item.id,
              text: item.text,
              _order: item._order,
            });
          }
        });

        if (isEmpty(subCategoryMenu)) {
          state.subMenuItemClicked = 0;
          state.bannerTxt = 'No categories found';
        } else {
          subCategoryMenu =
            state.mainMenuOrderBy === 'alpha' ||
            state.mainMenuOrderBy === '' ||
            state.mainMenuOrderBy === 0
              ? orderBy(subCategoryMenu, 'text', 'asc')
              : subCategoryMenu.sort((a, b) => {
                  return a._order - b._order;
                });
          state.subMenuItemClicked = subCategoryMenu[0].id;
          state.bannerTxt = subCategoryMenu[0].text;
        }
      } else {
        state.mainMenuItemClicked = action.id;
      }

      return Object.assign({}, state);
    /*case CHANGE_MENUITEMS:
      return Object.assign({}, state, {
        menuItems: action.newItems,
        bannerImage: action.bannerImage,
        bannerTxt: action.bannerTxt,
        subMenuItemClicked: action.subMenuItemClicked,
        mainMenuItemClicked: action.mainMenuItemClicked,
        pager: action.pagination,
        menuArray: action.menuArray,
      });*/
    case CHANGE_MENUITEMS:
      return Object.assign({}, state, {
        menuItems: action.newItems,
        bannerImage: action.bannerImage,
        bannerTxt: action.bannerTxt,
        subMenuItemClicked: action.subMenuItemClicked,
        pager: action.pagination,
      });
    case LOADINFINITE_MENUITEMS:
      return Object.assign({}, state, {
        menuItems: action.newItems,
        bannerImage: action.bannerImage,
        bannerTxt: action.bannerTxt,
        menuArray: action.menuArray,
      });
    case ISINFINITEBOOLVALUE:
      return Object.assign({}, state, {
        infiniteBoolValue: action.infiniteBoolValue,
      });
    case UPDATE_MENUITEMS:
      return Object.assign({}, state, {
        subMenuItemClicked: action.subMenuItemClicked,
        infiniteScroll: true,
      });
    case LOAD_PAGINATION_MENU_ITEMS:
      return Object.assign({}, state, {
        menuItems: action.newItems,
        pager: action.pagination,
        // menuArray: action.menuArray,
      });
    case LOAD_CATEGORY:
      return Object.assign({}, state, {
        menuCategories: action.menuCategories,
        mainMenuItemClicked: action.mainMenuItemClicked,
        mainMenuOrderBy: action.mainMenuOrderBy,
        mainMenuItemName: action.mainMenuItemName,
        subMenuItemClicked: action.subMenuItemClicked,
        bannerTxt: action.bannerTxt,
        menuArray: action.menuArray,
        infiniteBoolValue: false,
      });
    case ADDMENUIDS:
      return Object.assign({}, state, {
        mainMenuItemClicked: action.mainMenuItemClicked,
        subMenuItemClicked: action.subMenuItemClicked,
        mainMenuOrderBy: action.orderBy,
      });
    case CHANGE_CATEGORYID:
      return Object.assign({}, state, {
        subMenuItemClicked: action.subMenuItemClicked,
      });
    case LOAD_ITEMS:
      return Object.assign({}, state, {
        menuItems: action.items,
        bannerImage: action.bannerImage,
        pager: action.pagination,
        menuArray: action.menuArray,
        clickBooleanSubMenu: false,
      });
    case LOADING:
      return Object.assign({}, state, {
        loading: action.status,
      });
    case CLICKBOOLEAN:
      return Object.assign({}, state, {
        clickBooleanSubMenu: action.boolStatus,
      });
    case INFINITE_SCROLL:
      return Object.assign({}, state, {
        infiniteScroll: action.infiniteScroll,
      });
    case REHYDRATE:
      var incoming = action.payload.auth; //Returns updated state
      if (incoming) {
        return {
          ...state,
          ...incoming,
          loading: false, //Specific key for which state persisting is not required
        };
      } else {
        return {};
      }
    case UNSET_MENU:
      return Object.assign({}, state, {
        mainMenuItemClicked: '',
        subMenuItemClicked: '',
      });
    default:
      return state;
  }
}
export const getMenuCategories = state =>
  get(state, 'menuCategories.menuCategories', []);
export const getMainMenuClickItemId = state =>
  get(state, 'menuCategories.mainMenuItemClicked', '');
export const getSubMenuClickItemId = state =>
  get(state, 'menuCategories.subMenuItemClicked', '');

export const getMenu = createSelector(
  [getMenuCategories, getMainMenuClickItemId, getSubMenuClickItemId],
  (menuItems, parentId, childId) => ({
    menuItems,
    parentId,
    childId,
  })
);



// WEBPACK FOOTER //
// ./src/views/menu/reducer.js